import { motion } from "framer-motion"

type EmptyStateProps = {
  icon?: React.ReactNode
  title: string
  description?: string
  className?: string
}

const DefaultIcon = () => (
  <svg
    className="h-8 w-8 text-zinc-400"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z"
    />
  </svg>
)

const EmptyState = ({
  icon,
  title,
  description,
  className = "",
}: EmptyStateProps) => {
  return (
    <motion.div
      className={`py-24 text-center ${className}`}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 0.5 }}
    >
      <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-zinc-100">
        {icon || <DefaultIcon />}
      </div>
      <h3 className="text-lg font-semibold text-zinc-900">{title}</h3>
      {description && <p className="mt-2 text-zinc-500">{description}</p>}
    </motion.div>
  )
}

export default EmptyState
